import React, {useContext} from 'react';

import AffinityContextProvider from './AffinityContextProvider';
import AffinityContext from './AffinityContext';
import Loading from "../../components/Loading";
import LoadingPage from "../../views/LoadingPage";

/**
 * Inserts UserContextProvider in the react tree
 * before adding the given component.
 *
 * @param {Object} Component The component that needs the context provider.
 * @returns {Object} The component to render wrapped with the provider.
 */
const withAffinityContextProvider = (Component) => (props) => (
    <AffinityContextProvider>
        <Component {...props} />
    </AffinityContextProvider>
);

/**
 * Renders the given component when the user context is ready.
 *
 * @param {Object} Component The component to render.
 * @param {Object} Component The rendered component.
 * @returns {Object} The component to render or the LoadingPage component.
 */
const withAffinityContextReady = (Component) => (props) => {

    const {isReady} = useContext(AffinityContext);
    return isReady ? <Component {...props} /> :
        <LoadingPage/>;
};

export {
    withAffinityContextReady,
    withAffinityContextProvider,
};